/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { openDashboardDialog } from '@actions/dashboard-actions';
import { dismissBaselineAlert } from '@actions/groups-actions';
import { isWorkflowEnabled } from '@constants/config';
import * as dialog from '@constants/dialogs';
import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import StartCycleDialog from '@shared/dialogs/start-cycle-dialog';
import { canAccessWorkflow, getUserId } from '@utils/permission-utils';
import { withRouter } from '@utils/router-utils';
import { hasBaselineChanged } from '@utils/timeline-chart-utils';
import Details from './details';
import CycleList from './cycle-list';
import EntityList from './entity-list';
import Metrics from './metrics';
import './drawer.scss';

class Drawer extends Component {
  onMetricsTabActive = () => {
    const { group } = this.props;
    const ownerId = group.owner.id;
    // Only issue the API call to dismiss the alert, if we
    // show the alert (it will only appear if the baseline
    // has changes, and if the 'dismissed' flag from the
    // backend is not set).
    //
    // Also, to be able to dismiss it, the user must
    // be the group owner.
    if (this.hasChanges() && getUserId() === ownerId) {
      this.props.dismissBaselineAlert(group.id);
    }
    this.setState({ activeTab: 'metrics' });
  };

  hasChanges = () => {
    const { group } = this.props;
    const { baseline, current } = group;
    return hasBaselineChanged(baseline, current);
  };

  getStyles = () => {
    const { isTrayEmpty } = this.props;
    if (isTrayEmpty) {
      return {};
    }
    return {
      opacity: 0.4,
      pointerEvents: 'none',
      userSelect: 'none'
    };
  };

  startCycle = () => {
    const { group } = this.props;
    const params = { groupId: group.id, reloadGroup: true };
    this.props.openDashboardDialog(dialog.START_CYCLE, params);
  };

  render() {
    const { group, activeTab } = this.props;
    const canStartWorkflow = canAccessWorkflow('cycle', 'add');
    const renderActions = activeTab === 'cycles' && group && group.id && canStartWorkflow;
    return (
      <div styleName="group-drawer-container" style={this.getStyles()}>
        <div styleName="group-drawer-tabs-container">
          {activeTab === 'details' && <Details {...this.props} />}
          {activeTab === 'list' && <EntityList />}
          {activeTab === 'metrics' && <Metrics />}
          {activeTab === 'cycles' && <CycleList />}
        </div>
        {renderActions && (
          <div styleName="group-drawer-bottom-actions" role="presentation">
            <Button startIcon={<AddIcon />} onClick={this.startCycle} color="primary" fullWidth>
              START NEW
            </Button>
          </div>
        )}
        {isWorkflowEnabled() && canStartWorkflow && <StartCycleDialog />}
      </div>
    );
  }
}

Drawer.propTypes = {
  activeTab: PropTypes.string,
  dismissBaselineAlert: PropTypes.func,
  group: PropTypes.object,
  isTrayEmpty: PropTypes.bool,
  openDashboardDialog: PropTypes.func,
  params: PropTypes.object
};

const mapStateToProps = state => {
  const { group } = state.groups.edit;
  const { trays } = state.map;
  const isTrayEmpty = isEmpty(trays);
  return { group, isTrayEmpty };
};

const mapDispatchToProps = {
  dismissBaselineAlert,
  openDashboardDialog
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Drawer));
